var map = {
	"./icon_balance_statement.png": "dac5",
	"./icon_delivery_record.png": "0b3d",
	"./icon_forecast.png": "c70d",
	"./icon_is.png": "d1a3",
	"./icon_marketing_plan.png": "a65a",
	"./icon_performance.png": "6bb6",
	"./icon_planning.png": "dd75",
	"./icon_records.png": "d07c",
	"./icon_rules.png": "bd8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b2db";